import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the commission report view.
 * @extends JetView
 */
export default class tableComissionReportView extends JetView {
    /**
     * Configures the view.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        // Extend the summTreeColumn filter to calculate and display summary values
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Initialize result variable
                    var resultFormat = 0; // Initialize formatted result variable
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Sum values at level 1
                    });
                    // Format result based on column ID
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Update node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extend from existing summColumn filter
        );
        return {
            view: 'treetable', // Define the view type
            id: 'treetable', // Set the ID for the treetable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
            columns: [
                // Define columns for the treetable
                {
                    id: 'TypeName',
                    header: 'TypeName',
                    width: 300,
                    template: function (obj, common) {
                        if (obj.$group) return common.treetable(obj, common) + obj.value; // Display group name
                        return obj.NameAffiliate; // Display affiliate name
                    },
                    footer: 'Total:', // Footer label
                },
                {
                    id: 'ActionTittle',
                    header: '',
                    width: 70,
                    height: 25,
                    tooltip: 'Acción', // Tooltip for action column
                    template: function (obj) {
                        // Template for action buttons based on state and level
                        if ((obj.State == 'A' || obj.State == null) && obj.$level == 4) {
                            if (devConfig.getPermAction('comissionsReportBetShopApprove', 'Approve')) {
                                return "<span placeholder='Aprobar' class='webix_icon wxi-close approve prm-comissionsReportBetShopApprove'></span><span class='webix_icon icon-history torefuse prm-comissionsReportBetShopApprove'></span>";
                            } else {
                                return '';
                            }
                        } else {
                            if ((obj.State == 'P' || obj.State == null) && obj.$level == 4) {
                                if (devConfig.getPermAction('comissionsReportBetShopPay', 'Pay')) {
                                    return "<span placeholder='Pagar' class='webix_icon wxi-close pay prm-comissionsReportBetShopPay'></span>";
                                } else {
                                    return '';
                                }
                            } else {
                                return '';
                            }
                        }
                    },
                },
                { id: 'Id', header: 'ID', width: 70, sort: 'int' }, // ID column
                {
                    id: 'ClientId',
                    header: _('ID Afiliador'), // Localized header for affiliate ID
                    width: 95,
                    sort: 'int',
                },
                {
                    id: 'NameAffiliate',
                    header: _('Nombre Afiliador'), // Localized header for affiliate name
                    width: 200,
                    sort: 'int',
                },
                {
                    id: 'ClientRef',
                    header: _('Usuario REF'), // Localized header for REF user
                    width: 95,
                    sort: 'int',
                },
                {
                    id: 'CreatedLocal',
                    header: _('Fecha de creación'), // Localized header for creation date
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text',
                    format: dateFormat, // Date formatting
                },
                {
                    id: 'CurrencyId',
                    header: _('Moneda'), // Localized header for currency
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'AmountBase',
                    header: _('Valor Base'), // Localized header for base value
                    width: 100,
                    sort: 'int',
                    format: webix.Number.numToStr({
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }),
                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                    editor: 'text', // Editor type
                },
                {
                    id: 'Amount',
                    header: _('Comision'), // Localized header for commission
                    width: 100,
                    sort: 'int',
                    format: webix.Number.numToStr({
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }),
                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                    editor: 'text', // Editor type
                },
                {
                    id: 'AmountPaid',
                    header: _('Valor Pagado'), // Localized header for paid value
                    width: 100,
                    sort: 'int',
                    format: webix.Number.numToStr({
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }),
                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                    editor: 'text', // Editor type
                },
                {
                    id: 'State',
                    header: _('Estado'), // Localized header for state
                    options: [
                        { id: '', value: _('None') }, // Option for no state
                        { id: 'A', value: _('Activo') }, // Active state
                        { id: 'I', value: _('Pagada') }, // Paid state
                        { id: 'P', value: _('Pendiente') }, // Pending state
                        { id: 'R', value: _('Rechazada') }, // Rejected state
                    ],
                },
                {
                    id: 'ModifiedLocal',
                    header: _('Modificado'), // Localized header for modified date
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text',
                    format: dateFormat, // Date formatting
                },
            ],
            onClick: {
                // Event handler for payment action
                pay: function (euv, id) {
                    var vthis = this; // Reference to the current context
                    webix
                        .modalbox({
                            title: _('Pregunta '), // Modal title
                            buttons: [
                                _('Efectivo'), // Cash option
                                _('Saldo Recarga'), // Recharge balance option
                                _('Saldo Juego'), // Game balance option
                                _('Saldo Afiliados'), // Affiliate balance option
                                _('Cancelar'), // Cancel option
                            ],
                            text: _('Seleccione el tipo de saldo '), // Modal text
                            width: 500,
                        })
                        .then(function (result) {
                            switch (result) {
                                case '0':
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea pagar comisión en efectivo?'), // Confirmation text
                                        ok: _('Pagar Comisión'), // Confirm button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            if (action === true) {
                                                var item = vthis.getItem(id); // Get the item
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisions', // API endpoint
                                                        '{ "Id":"' +
                                                            item.Id +
                                                            '", "Type":"0", "Partner":"' +
                                                            id_partner +
                                                            '"}', // Request body
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    _('Error! '), // Error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                data = JSON.parse(
                                                                    text, // Parse response
                                                                );
                                                                if (!data.HasError) {
                                                                    item.State = 'I'; // Update item state to paid
                                                                    webix.message(
                                                                        _('Comisión Pagada'), // Success message
                                                                    );
                                                                    webix
                                                                        .ui({
                                                                            view: 'window',
                                                                            width: 500,
                                                                            height: 700,
                                                                            head: {
                                                                                view: 'toolbar',
                                                                                cols: [
                                                                                    {
                                                                                        view: 'label',
                                                                                        label: _('Factura'), // Invoice label
                                                                                    },
                                                                                    {
                                                                                        view: 'button',
                                                                                        label: 'X', // Close button
                                                                                        width: 100,
                                                                                        align: 'right',
                                                                                        click: "$$('windowfact2').close();", // Close action
                                                                                    },
                                                                                ],
                                                                            },
                                                                            id: 'windowfact2', // Window ID
                                                                            modal: true, // Modal window
                                                                            position: 'center', // Center position
                                                                            body: {
                                                                                rows: [
                                                                                    {
                                                                                        template:
                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // PDF display
                                                                                    },
                                                                                ],
                                                                            },
                                                                        })
                                                                        .show(); // Show the window
                                                                    var reader = new FileReader(); // File reader for PDF
                                                                    reader.onload = function (event) {
                                                                        $$('pdf').clear(); // Clear previous PDF
                                                                        $$('pdf').parse({
                                                                            data: event.target.result, // Parse new PDF data
                                                                        });
                                                                    };
                                                                    function b64toBlob(
                                                                        b64Data,
                                                                        contentType,
                                                                        sliceSize,
                                                                    ) {
                                                                        contentType = contentType || '';
                                                                        sliceSize = sliceSize || 512; // Default slice size
                                                                        var byteCharacters = atob(
                                                                            b64Data, // Decode base64 data
                                                                        );
                                                                        var byteArrays = [];
                                                                        for (
                                                                            var offset = 0;
                                                                            offset < byteCharacters.length;
                                                                            offset += sliceSize
                                                                        ) {
                                                                            var slice = byteCharacters.slice(
                                                                                offset,
                                                                                offset + sliceSize,
                                                                            );
                                                                            var byteNumbers = new Array(slice.length);
                                                                            for (var i = 0; i < slice.length; i++) {
                                                                                byteNumbers[i] = slice.charCodeAt(i); // Convert characters to byte numbers
                                                                            }
                                                                            var byteArray = new Uint8Array(byteNumbers);
                                                                            byteArrays.push(
                                                                                byteArray, // Push byte array to arrays
                                                                            );
                                                                        }
                                                                        var blob = new Blob(byteArrays, {
                                                                            type: contentType, // Create blob with content type
                                                                        });
                                                                        return blob; // Return the blob
                                                                    }
                                                                    var contentType = 'application/pdf'; // PDF content type
                                                                    var b64Data = data.Pdf; // Base64 PDF data
                                                                    var blob = b64toBlob(
                                                                        b64Data,
                                                                        contentType, // Convert to blob
                                                                    );
                                                                    var file = window.URL.createObjectURL(
                                                                        blob, // Create object URL for blob
                                                                    );
                                                                    console.log(
                                                                        blob, // Log the blob
                                                                    );
                                                                    document.querySelector('iframe').src = file; // Set iframe source to file
                                                                    var printWindow = window.open(
                                                                        file,
                                                                        '',
                                                                        'width=800,height=500', // Open print window
                                                                    );
                                                                    printWindow.print(); // Trigger print
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '1':
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text:
                                            _('Advertencia!') + '<br/>' + _('Desea abonar comisión a saldo recargas?'), // Confirmation text
                                        ok: _('Pagar Comisión'), // Confirm button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            if (action === true) {
                                                var item = vthis.getItem(id); // Get the item
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisions', // API endpoint
                                                        '{ "Id":"' +
                                                            item.Id +
                                                            '", "Type":"1", "Partner":"' +
                                                            id_partner +
                                                            '"}', // Request body
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    _('Error! '), // Error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                data = JSON.parse(
                                                                    text, // Parse response
                                                                );
                                                                if (!data.HasError) {
                                                                    item.State = 'I'; // Update item state to paid
                                                                    webix.message(
                                                                        _('Comisión Pagada'), // Success message
                                                                    );
                                                                    webix
                                                                        .ui({
                                                                            view: 'window',
                                                                            width: 500,
                                                                            height: 700,
                                                                            head: {
                                                                                view: 'toolbar',
                                                                                cols: [
                                                                                    {
                                                                                        view: 'label',
                                                                                        label: _('Factura'), // Invoice label
                                                                                    },
                                                                                    {
                                                                                        view: 'button',
                                                                                        label: 'X', // Close button
                                                                                        width: 100,
                                                                                        align: 'right',
                                                                                        click: "$$('windowfact2').close();", // Close action
                                                                                    },
                                                                                ],
                                                                            },
                                                                            id: 'windowfact2', // Window ID
                                                                            modal: true, // Modal window
                                                                            position: 'center', // Center position
                                                                            body: {
                                                                                rows: [
                                                                                    {
                                                                                        template:
                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // PDF display
                                                                                    },
                                                                                ],
                                                                            },
                                                                        })
                                                                        .show(); // Show the window
                                                                    var reader = new FileReader(); // File reader for PDF
                                                                    reader.onload = function (event) {
                                                                        $$('pdf').clear(); // Clear previous PDF
                                                                        $$('pdf').parse({
                                                                            data: event.target.result, // Parse new PDF data
                                                                        });
                                                                    };
                                                                    function b64toBlob(
                                                                        b64Data,
                                                                        contentType,
                                                                        sliceSize,
                                                                    ) {
                                                                        contentType = contentType || '';
                                                                        sliceSize = sliceSize || 512; // Default slice size
                                                                        var byteCharacters = atob(
                                                                            b64Data, // Decode base64 data
                                                                        );
                                                                        var byteArrays = [];
                                                                        for (
                                                                            var offset = 0;
                                                                            offset < byteCharacters.length;
                                                                            offset += sliceSize
                                                                        ) {
                                                                            var slice = byteCharacters.slice(
                                                                                offset,
                                                                                offset + sliceSize,
                                                                            );
                                                                            var byteNumbers = new Array(slice.length);
                                                                            for (var i = 0; i < slice.length; i++) {
                                                                                byteNumbers[i] = slice.charCodeAt(i); // Convert characters to byte numbers
                                                                            }
                                                                            var byteArray = new Uint8Array(byteNumbers);
                                                                            byteArrays.push(
                                                                                byteArray, // Push byte array to arrays
                                                                            );
                                                                        }
                                                                        var blob = new Blob(byteArrays, {
                                                                            type: contentType, // Create blob with content type
                                                                        });
                                                                        return blob; // Return the blob
                                                                    }
                                                                    var contentType = 'application/pdf'; // PDF content type
                                                                    var b64Data = data.Pdf; // Base64 PDF data
                                                                    var blob = b64toBlob(
                                                                        b64Data,
                                                                        contentType, // Convert to blob
                                                                    );
                                                                    var file = window.URL.createObjectURL(
                                                                        blob, // Create object URL for blob
                                                                    );
                                                                    console.log(
                                                                        blob, // Log the blob
                                                                    );
                                                                    document.querySelector('iframe').src = file; // Set iframe source to file
                                                                    var printWindow = window.open(
                                                                        file,
                                                                        '',
                                                                        'width=800,height=500', // Open print window
                                                                    );
                                                                    printWindow.print(); // Trigger print
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '2':
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea abonar comisión a saldo juego?'), // Confirmation text
                                        ok: _('Pagar Comisión'), // Confirm button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            if (action === true) {
                                                var item = vthis.getItem(id); // Get the item
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisions', // API endpoint
                                                        '{ "Id":"' +
                                                            item.Id +
                                                            '", "Type":"2", "Partner":"' +
                                                            id_partner +
                                                            '"}', // Request body
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    _('Error! '), // Error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                data = JSON.parse(
                                                                    text, // Parse response
                                                                );
                                                                if (!data.HasError) {
                                                                    item.State = 'I'; // Update item state to paid
                                                                    webix.message(
                                                                        _('Comisión Pagada'), // Success message
                                                                    );
                                                                    webix
                                                                        .ui({
                                                                            view: 'window',
                                                                            width: 500,
                                                                            height: 700,
                                                                            head: {
                                                                                view: 'toolbar',
                                                                                cols: [
                                                                                    {
                                                                                        view: 'label',
                                                                                        label: _('Factura'), // Invoice label
                                                                                    },
                                                                                    {
                                                                                        view: 'button',
                                                                                        label: 'X', // Close button
                                                                                        width: 100,
                                                                                        align: 'right',
                                                                                        click: "$$('windowfact2').close();", // Close action
                                                                                    },
                                                                                ],
                                                                            },
                                                                            id: 'windowfact2', // Window ID
                                                                            modal: true, // Modal window
                                                                            position: 'center', // Center position
                                                                            body: {
                                                                                rows: [
                                                                                    {
                                                                                        template:
                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // PDF display
                                                                                    },
                                                                                ],
                                                                            },
                                                                        })
                                                                        .show(); // Show the window
                                                                    var reader = new FileReader(); // File reader for PDF
                                                                    reader.onload = function (event) {
                                                                        $$('pdf').clear(); // Clear previous PDF
                                                                        $$('pdf').parse({
                                                                            data: event.target.result, // Parse new PDF data
                                                                        });
                                                                    };
                                                                    function b64toBlob(
                                                                        b64Data,
                                                                        contentType,
                                                                        sliceSize,
                                                                    ) {
                                                                        contentType = contentType || '';
                                                                        sliceSize = sliceSize || 512; // Default slice size
                                                                        var byteCharacters = atob(
                                                                            b64Data, // Decode base64 data
                                                                        );
                                                                        var byteArrays = [];
                                                                        for (
                                                                            var offset = 0;
                                                                            offset < byteCharacters.length;
                                                                            offset += sliceSize
                                                                        ) {
                                                                            var slice = byteCharacters.slice(
                                                                                offset,
                                                                                offset + sliceSize,
                                                                            );
                                                                            var byteNumbers = new Array(slice.length);
                                                                            for (var i = 0; i < slice.length; i++) {
                                                                                byteNumbers[i] = slice.charCodeAt(i); // Convert characters to byte numbers
                                                                            }
                                                                            var byteArray = new Uint8Array(byteNumbers);
                                                                            byteArrays.push(
                                                                                byteArray, // Push byte array to arrays
                                                                            );
                                                                        }
                                                                        var blob = new Blob(byteArrays, {
                                                                            type: contentType, // Create blob with content type
                                                                        });
                                                                        return blob; // Return the blob
                                                                    }
                                                                    var contentType = 'application/pdf'; // PDF content type
                                                                    var b64Data = data.Pdf; // Base64 PDF data
                                                                    var blob = b64toBlob(
                                                                        b64Data,
                                                                        contentType, // Convert to blob
                                                                    );
                                                                    var file = window.URL.createObjectURL(
                                                                        blob, // Create object URL for blob
                                                                    );
                                                                    console.log(
                                                                        blob, // Log the blob
                                                                    );
                                                                    document.querySelector('iframe').src = file; // Set iframe source to file
                                                                    var printWindow = window.open(
                                                                        file,
                                                                        '',
                                                                        'width=800,height=500', // Open print window
                                                                    );
                                                                    printWindow.print(); // Trigger print
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '3':
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text:
                                            _('Advertencia!') + '<br/>' + _('Desea abonar comisión a saldo afiliados?'), // Confirmation text
                                        ok: _('Pagar Comisión'), // Confirm button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            if (action === true) {
                                                var item = vthis.getItem(id); // Get the item
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisions', // API endpoint
                                                        '{ "Id":"' + item.Id + '", "Type":"3"}', // Request body
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    'Error! ', // Error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                data = JSON.parse(
                                                                    text, // Parse response
                                                                );
                                                                if (!data.HasError) {
                                                                    item.State = 'I'; // Update item state to paid
                                                                    webix.message(
                                                                        _('Comisión Pagada'), // Success message
                                                                    );
                                                                    webix
                                                                        .ui({
                                                                            view: 'window',
                                                                            width: 500,
                                                                            height: 700,
                                                                            head: {
                                                                                view: 'toolbar',
                                                                                cols: [
                                                                                    {
                                                                                        view: 'label',
                                                                                        label: _('Factura'), // Invoice label
                                                                                    },
                                                                                    {
                                                                                        view: 'button',
                                                                                        label: 'X', // Close button
                                                                                        width: 100,
                                                                                        align: 'right',
                                                                                        click: "$$('windowfact2').close();", // Close action
                                                                                    },
                                                                                ],
                                                                            },
                                                                            id: 'windowfact2', // Window ID
                                                                            modal: true, // Modal window
                                                                            position: 'center', // Center position
                                                                            body: {
                                                                                rows: [
                                                                                    {
                                                                                        template:
                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // PDF display
                                                                                    },
                                                                                ],
                                                                            },
                                                                        })
                                                                        .show(); // Show the window
                                                                    var reader = new FileReader(); // File reader for PDF
                                                                    reader.onload = function (event) {
                                                                        $$('pdf').clear(); // Clear previous PDF
                                                                        $$('pdf').parse({
                                                                            data: event.target.result, // Parse new PDF data
                                                                        });
                                                                    };
                                                                    function b64toBlob(
                                                                        b64Data,
                                                                        contentType,
                                                                        sliceSize,
                                                                    ) {
                                                                        contentType = contentType || '';
                                                                        sliceSize = sliceSize || 512; // Default slice size
                                                                        var byteCharacters = atob(
                                                                            b64Data, // Decode base64 data
                                                                        );
                                                                        var byteArrays = [];
                                                                        for (
                                                                            var offset = 0;
                                                                            offset < byteCharacters.length;
                                                                            offset += sliceSize
                                                                        ) {
                                                                            var slice = byteCharacters.slice(
                                                                                offset,
                                                                                offset + sliceSize,
                                                                            );
                                                                            var byteNumbers = new Array(slice.length);
                                                                            for (var i = 0; i < slice.length; i++) {
                                                                                byteNumbers[i] = slice.charCodeAt(i); // Convert characters to byte numbers
                                                                            }
                                                                            var byteArray = new Uint8Array(byteNumbers);
                                                                            byteArrays.push(
                                                                                byteArray, // Push byte array to arrays
                                                                            );
                                                                        }
                                                                        var blob = new Blob(byteArrays, {
                                                                            type: contentType, // Create blob with content type
                                                                        });
                                                                        return blob; // Return the blob
                                                                    }
                                                                    var contentType = 'application/pdf'; // PDF content type
                                                                    var b64Data = data.Pdf; // Base64 PDF data
                                                                    var blob = b64toBlob(
                                                                        b64Data,
                                                                        contentType, // Convert to blob
                                                                    );
                                                                    var file = window.URL.createObjectURL(
                                                                        blob, // Create object URL for blob
                                                                    );
                                                                    console.log(
                                                                        blob, // Log the blob
                                                                    );
                                                                    document.querySelector('iframe').src = file; // Set iframe source to file
                                                                    var printWindow = window.open(
                                                                        file,
                                                                        '',
                                                                        'width=800,height=500', // Open print window
                                                                    );
                                                                    printWindow.print(); // Trigger print
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '4':
                                    break; // No action for case 4
                            }
                        });
                },
                approve: function (euv, id) {
                    var vthis = this; // Reference to the current context
                    webix.confirm({
                        type: 'confirm-warning',
                        text: _('Advertencia!') + '<br/>' + _('Desea Aprobar Comisión'), // Confirmation text
                        ok: _('Aprobar Comisión'), // Confirm button text
                        cancel: _('Salir'), // Cancel button text
                        callback: function (action) {
                            if (action === true) {
                                var item = vthis.getItem(id); // Get the item
                                webix
                                    .ajax()
                                    .headers({
                                        'Content-type': 'application/json', // Set content type
                                    })
                                    .post(
                                        devConfig.geturlApi() + 'Commisions/ApproveComission', // API endpoint
                                        '{ "Id":' + item.Id + '}', // Request body
                                        {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message(_('Error! ')); // Error message
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                data = JSON.parse(text); // Parse response
                                                if (!data.HasError) {
                                                    item.State = 'P'; // Update item state to approved
                                                    webix.message(
                                                        _('Comision Aprobado'), // Success message
                                                    );
                                                }
                                            },
                                        },
                                    );
                            }
                        },
                    });
                },
            },
            tooltip: true, // Enable tooltips
            footer: true, // Enable footer
            math: true, // Enable math calculations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager ID
        };
    }

    /**
     * Initializes the grid and sets up event handlers.
     * @param {Object} grid - The grid instance.
     */
    init(grid) {
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        const _ = this.app.getService('locale')._; // Localization service
        var url = devConfig.geturlApi() + 'es/Financial/GetComissionsResume?Partner=' + id_partner + '&'; // API URL for fetching commission resume
        var filter = ''; // Initialize filter variable

        // Event handler for after loading data into the grid
        grid.attachEvent('onAfterLoad', function () {
            $$('treetable').data.group({
                by: 'NameAffiliate', // Group by affiliate name
                map: {
                    NameAffiliate: ['NameAffiliate'],
                    ClientId: ['ClientId'],
                    AmountBase: ['AmountBase', 'sum'], // Sum base amount
                    AmountPaid: ['AmountPaid', 'sum'], // Sum paid amount
                    Amount: ['Amount', 'sum'], // Sum commission amount
                    TypeName: ['TypeName'],
                    CurrencyId: ['CurrencyId'],
                },
            });
            $$('treetable').data.group({
                by: 'TypeName', // Group by type name
                map: {
                    TypeName: ['TypeName'],
                    AmountBase: ['AmountBase', 'sum'], // Sum base amount
                    AmountPaid: ['AmountPaid', 'sum'], // Sum paid amount
                    Amount: ['Amount', 'sum'], // Sum commission amount
                    CurrencyId: ['CurrencyId'],
                },
            });
            $$('treetable').data.group({
                by: 'CurrencyId', // Group by currency ID
                map: {
                    CurrencyId: ['CurrencyId'],
                    AmountBase: ['AmountBase', 'sum'], // Sum base amount
                    AmountPaid: ['AmountPaid', 'sum'], // Sum paid amount
                    Amount: ['Amount', 'sum'], // Sum commission amount
                },
            });
        });

        // Event handler for filtering data
        this.on(this.app, 'depositReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append filter parameters
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Append partner ID to filter string
            grid.clearAll(); // Clear grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter variable
        });

        // Event handler for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event handler for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('deposit:id', [item.Id]); // Trigger event with item ID
        });

        // Event handler for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + user, // Load data based on selected player
            );
        });
    }
}

// FILE DOCUMENTED
